<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>DiCentral Business</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>
    <main id="cont">
      <div class="subCon caseCon inner_box">
        <section id="financial">
          <h3 class="con_tit">DiCentral for Finance Service</h3>

          <div class="con">
            <div class="inner_box">
              <dl class="txtBox">
                <dt>Financial Services</dt>

                <dd>
                  송장 처리 오류를 제거하고 비즈니스 규칙 준수를 보장하는 것은
                  매우 중요합니다.<br />
                  DiCentral의 클라우드 기반 금융 EDI 솔루션은 은행과 파트너
                  간의<br />
                  원활한 의사소통 프로토콜을 제공하므로 현금 흐름을
                  최적화하고<br />
                  금융 시스템 가시성을 확보하여 보다 정확한 정보를 바탕으로<br />
                  실시간 비즈니스 의사 결정을 내릴 수 있습니다.
                </dd>
              </dl>

              <section class="subsc">
                <div class="damage">
                  <dl>
                    <dt>DiCentral 도입효과</dt>
                    <dd>
                      <ol>
                        <li>
                          <span>01</span> <em>ROI 달성</em><br />
                          업체간의 데이터를 ERP/WMS와 통합하여 복잡하거나 고유한
                          규칙을 관리하도록 사용자 지정 운영 및 재무 EDI 활동의
                          중앙 대시보드를 제공
                        </li>
                        <li>
                          <span>02</span> <em>현금 관리 간소화</em><br />
                          고객, 공급업체 및 금융 파트너 에코시스템을 연결하여
                          현금 흐름을 최적화하고 현금 관리를 개선할 수 있습니다.
                        </li>
                        <li>
                          <span>03</span> <em>비지니스 인텔리전스</em><br />
                          조직 전체의 영업 데이터를 분석하여 영업 실적을 향상
                        </li>
                        <li>
                          <span>04</span> <em>오류 발생 예방</em><br />
                          사전 모니터링 및 알림을 제공하여 비즈니스 규칙 준수를
                          보장하고 규칙 위반이 발생하기 전에 이를 방지
                        </li>
                      </ol>
                    </dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </section>
        <!-- #financial -->

        <section id="ecomm">
          <h3 class="con_tit">DiCentral for E-Commerce</h3>

          <div class="con">
            <div class="inner_box">
              <dl class="txtBox">
                <dt>E-Commerce</dt>

                <dd>
                  DiCentral의 B2B 전자 상거래 솔루션을 사용하면<br />
                  전자 상거래에서효율적인 물류시스템 관리를 위해재고 관리, 제품
                  관리 및<br />
                  트랜잭션 데이터를 자동화하고 고객이 기대하는 양질의 서비스를
                  제공할 수 있습니다.<br /><br /><br />
                </dd>
              </dl>

              <section class="subsc">
                <div class="damage">
                  <dl>
                    <dt>DiCentral 도입효과</dt>
                    <dd>
                      <ol>
                        <li>
                          <span>01</span> <em>고객 관리</em><br />
                          고객이 원하는 때에 원하는 제품을 받을 수 있도록 실시간
                          창고 재고 정보를 제공하는 데 도움이 됩니다.
                        </li>
                        <li>
                          <span>02</span> <em>리테일 및 벤더 주문에 적합</em
                          ><br />
                          업체간의 효율적인 주문서 등을 통합하여 주문, 포장 목록
                          및 배송 라벨을 배송 및 입고에 대해서도 동일한 가시성을
                          유지
                        </li>
                        <li>
                          <span>03</span> <em>통합 및 자동화</em><br />
                          파트너와 신속하게 연결되며 외부 데이터를 기존
                          ERP(Enterprise Resource Planning), WMS(Warehouse
                          Management System) 또는 회계 소프트웨어에 통합합니다.
                        </li>
                        <li>
                          <span>04</span> <em>고객에 맞는 정보 제공</em><br />
                          실시간 창고 재고 정보, 배송 정보 및 모바일 알림
                          프로그램처럼 가장 적합한 데이터 및 진행 상황, 예외
                          사항을 알려주는 사용자 지정 대시보드를 생성합니다.
                        </li>
                      </ol>
                    </dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </section>
        <!-- #media -->

        <section id="logi">
          <h3 class="con_tit">DiCentral for Logistics & Distribution</h3>

          <div class="con">
            <div class="inner_box">
              <dl class="txtBox">
                <dt>Logistics & Distribution</dt>

                <dd>
                  조직은 자동화된 시스템에 의존하여 효율성을 높이고<br />
                  창고 또는 유통 센터 안팎으로 제품을 옮기는 비용을
                  절감합니다.<br />
                  DiCentral의 EDI 배포 솔루션은 재고 및 배송 프로세스에 대한
                  실시간 정보를 제공하여<br />
                  정시 제품 제공을 보장하고 물류시스템 협업을 개선합니다.<br /><br />
                </dd>
              </dl>

              <section class="subsc">
                <div class="damage">
                  <dl>
                    <dt>DiCentral 도입효과</dt>
                    <dd>
                      <ol>
                        <li>
                          <span>01</span> <em>실시간 인벤토리 가시성</em><br />
                          여러 웨어하우스를 드나드는 재고의 수량, 위치 및 상태를
                          완벽하게 파악할 수 있도록 지원
                        </li>
                        <li>
                          <span>02</span> <em>WMS, TMS, EDI 통합</em><br />
                          실시간 가시성을 제공하므로 문제를 식별하고 중요한
                          물류, 주문 및 결제 변경 사항을 구현
                        </li>
                        <li>
                          <span>03</span> <em>재고 오류 예방</em><br />
                          규정 준수 문제 및 처리 오류를 사전에 방지하고 거래
                          파트너의 복잡한 비즈니스 규칙을 준수
                        </li>
                      </ol>
                    </dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </section>
        <!-- #health -->

        <section id="proc">
          <h3 class="con_tit">DiCentral for Procurement & Merchandising</h3>

          <div class="con">
            <div class="inner_box">
              <dl class="txtBox">
                <dt>Procurement & Merchandising</dt>

                <dd>
                  DiCentral의 클라우드 기반 조달 EDI 솔루션을 통해<br />
                  구매 및 판매 전문가는 주문 이행 프로세스에 대한<br />
                  실시간 가시성과 함께 제품 특성 및 재고관리에 대한 정확한 최신
                  정보를 받을 수 있습니다.<br /><br /><br />
                </dd>
              </dl>

              <section class="subsc">
                <div class="damage">
                  <dl>
                    <dt>DiCentral 도입효과</dt>
                    <dd>
                      <ol>
                        <li>
                          <span>01</span>
                          <em>오류 감소 및 데이터 정확도 증가</em><br />
                          거래 커뮤니티의 최신 제품 특성과 재고 업데이트를
                          활용하여 기존에 수작업으로 진행하던 프로세스와 관련된
                          오류를 줄이는데 도움이 됩니다.
                        </li>
                        <li>
                          <span>02</span>
                          <em>시간 단축</em><br />
                          EDI 기능 승인, 구매 주문 확인 및 구매 주문 변경 사항을
                          물류 프로세스에 쉽게 통합하여 공급 업체와의 상태
                          업데이트를 자동화합니다.
                        </li>
                        <li>
                          <span>03</span>
                          <em>공급 업체 온 보딩 및 EDI 채택 증가</em><br />
                          새로운 기술을 도입할 때 발생할 수 있는 어려움을 보다
                          쉽게 해결할 수 있습니다. DI-Central은 업체들간
                          사용하고있는 각각의 시스템과 원활하게 소통하고
                          조율합니다.
                        </li>
                        <li>
                          <span>04</span>
                          <em>가장 유용한 정보 제공</em><br />
                          관련성이 높은 예측 및 트렌드 데이터를 필터링, 편집하여
                          사용자 지정 대시보드를 생성하고 모바일 알림을 설정하여
                          구매 주문 상태를 알려줍니다
                        </li>
                      </ol>
                    </dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </section>
        <!-- #travel -->

        <section id="small">
          <h3 class="con_tit">DiCentral for Small Business</h3>

          <div class="con">
            <div class="inner_box">
              <dl class="txtBox">
                <dt>Small Business</dt>

                <dd>
                  소규모 비즈니스 소유자의 경우 유통 센터를 보충하거나 고객에게
                  직접 배송하는<br />
                  것이 어려울 수 있으며 배송 마감일을 놓치거나 비효과적인 예외
                  관리로 고객을 잃을 위험이 있습니다.<br />
                  소기업을위한 DiCentral의 클라우드 기반 EDI 솔루션은 비즈니스에
                  쉽게 통합됩니다.<br /><br /><br />
                </dd>
              </dl>

              <section class="subsc">
                <div class="damage">
                  <dl>
                    <dt>DiCentral 도입효과</dt>
                    <dd>
                      <ol>
                        <li>
                          <span>01</span>
                          <em>통합 및 자동화</em><br />
                          오류가 발생하기 쉬운 수동 입력은 비용이 많이 드는 규정
                          준수 관련 불이익을 초래할 수 있습니다. 클라우드 기반
                          EDI 플랫폼은 업체들간에 신속하게 연결되며 외부
                          데이터를 기존 ERP, WMS 또는 회계 소프트웨어에
                          통합합니다.
                        </li>
                        <li>
                          <span>02</span>
                          <em>환불 규제</em><br />
                          예외 관리를 하는 것은 고객만족도를 유지하는데
                          중요합니다. DiCentral의 클라우드 기반 EDI 솔루션은
                          사전 경고 및 트랜잭션 격리 기능을 통해 고객별 비즈니스
                          활동을 모니터링 하여 만족도를 높입니다.
                        </li>
                        <li>
                          <span>03</span>
                          <em>편리하고 쉬운 사용</em><br />
                          어디서든 통제 가능한 모바일 알림 및 지능형 대시 보드를
                          통해 휴대폰으로 바로 전송되는 정보를 수신할 수
                          있습니다. 구매 주문 인식 마감일부터 배송 완료에
                          이르기까지 모든 정보를 얻을 수 있습니다.
                        </li>
                      </ol>
                    </dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
